// 身份类型
const identityTypes = [
  {
    label: '居民身份证',
    value: 1
  },
  {
    label: '香港特区护照/身份证明',
    value: 2
  },
  {
    label: '澳门特区护照/身份证明',
    value: 3
  },
  {
    label: '台湾居民来往大陆通行证',
    value: 4
  },
  {
    label: '境外永久居住证',
    value: 5
  },
  {
    label: '其他',
    value: 6
  }
]

// 性别
const gender = [
  {
    label: '男',
    value: 0
  },
  {
    label: '女',
    value: 1
  }
]

// 身份
const identity = [
  {
    label: '学生',
    value: 0
  },
  {
    label: '教职工',
    value: 1
  }
]

export default {
  identityTypes,
  gender,
  identity
}
